import {athlets} from "./athlets"
import {organizations} from "./organizations"
import {sports} from "./sports"
import {users} from "./users"
import {protocols} from "./protocols"
import {typesOfExamination} from "./types-of-examination"
import {normatives} from "./normatives"
import {trainingGroups} from "./trainingGroups"
import {measureUnits} from "./measure-units"
import {measure} from "./measure"
import {coaches} from "@/app/routes/coaches";
import {exerciseCategory} from "@/app/routes/exercise-category";

export {
    athlets,
    organizations,
    sports,
    users,
    protocols,
    typesOfExamination,
    normatives,
    trainingGroups,
    measureUnits,
    measure,
}

export const all = [
    ...athlets,
    ...organizations,
    ...sports,
    ...users,
    ...protocols,
    ...typesOfExamination,
    ...normatives,
    ...trainingGroups,
    ...measureUnits,
    ...measure,
    ...coaches,
    ...exerciseCategory,
]
